import { Component, OnInit, EventEmitter } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { CartService } from 'src/app/services/cart.service';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { StorageService } from 'src/app/services/storage.service';
import { FbService } from 'src/app/services/fb.service';
import { GtagService } from 'src/app/services/gtag.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'pagamento-page',
  templateUrl: './pagamento-page.component.html',
  styleUrls: ['./pagamento-page.component.scss']
})
export class PagamentoPage implements OnInit {

  public onSaveDadosComprador = new EventEmitter();
  public onSendPagamento      = new EventEmitter();
  public step     = 1;
  public loader   = false;
  public message  = "";
  public response = {
    data: "",
    status: null
  };
  public responsePagamento: any = {
    dataFile: {
      data: null,
      status: null
    },
    dataPay: {
      data: null,
      status: null
    }
  };
  public carrinho = null;
  public dadosComprador: any = {};
  public formasPagamento     = [];
  public fileSession         = null;
  public isPagamento         = false;
  public pagamentoSuccessId  = null;
  public loaderPagamento     = false;
  public isSendAnalytics     = false;
  public itensBreadcrumbs    = [];
  public sendPagamento       = new EventEmitter();
  public usuario             = null;
  public disabledSend        = false;
  public dataItem:any        = {};
  
  constructor(
    private api: ApiService,
    private app: AppService,
    private cart: CartService,
    private router: Router,
    private usuarioService: UsuarioService,
    private storage: StorageService ,
    private fb: FbService,
    private gtag: GtagService,
    private data:DataService
  ){} 
  /**
   *
   * Busca os dados do Carrinho
   *
   *
   */
  getCart() {
    
    try {
     
      this.loader = true;
      this.message = ""; 
      
      this.api.cart().get().subscribe(response => {
        
        this.loader = false;
        this.response = response;
        
        if(response.status == 1) {

          this.usuario = response.usuario;  

          if(response.data != null) {

            this.cart.emitirUpdateTotalCart.emit({
              total: response.data.total,
              qtd: response.data.cart_itens.length
            });
            this.carrinho = response.data;
            this.carrinho.usuario = this.usuario;
            this.formasPagamento = response.data.formas_pagamento;
            this.dadosComprador = response.data.cart_dados;
            if (this.dadosComprador.nome !== null && this.dadosComprador.nome !== "") {
              setTimeout(() => {
                this.step = 2;
              }, 100);
            }
          }else if (response.fileSession) {
            this.carrinho = response.cart_pagamento;
            this.formasPagamento = response.cart_pagamento.formas_pagamento;
            this.dadosComprador = response.cart_pagamento.cart_dados;
            this.fileSession = response.fileSession;
            this.step = 2;
          }else if (response.pagamentoSucessoId) {
            this.carrinho = response.cart_pagamento;
            this.formasPagamento = response.cart_pagamento.formas_pagamento;
            this.dadosComprador = response.cart_pagamento.cart_dados;
            this.pagamentoSuccessId = response.pagamentoSuccessId;
            this.isPagamento = true;
            this.step = 3;
            this.toConfirmacao();
          }
          else {
            
            this.cart.emitirUpdateTotalCart.emit({
              total: 0,
              qtd: 0
            });
            this.router.navigateByUrl("/");
          
          }
        }
        this.app.toTop();

      }, (err) => {
        this.loader = false;
      });
    }
    catch (e) {
      this.loader = false;
    }
  }
  /**
   * 
   * Set breadcrumbs
   * 
   */
  setItensBreadcrumbs(){

    this.itensBreadcrumbs.push({
      text: "Carrinho",
      routerLink: "/carrinho"
    }); 
    this.itensBreadcrumbs.push({
      text: "Informações do Pagamento" 
    }); 

  }
  /**
   * 
   * Click
   * 
   */
  _finalizar(){
    
    if(this.usuario == null){
      this.app.info("Faça o login para continuar.");
      return false;
    }

    this.disabledSend = true;
    this.sendPagamento.emit(); 
    
  }
  /**
   * 
   * Seta o usuário
   * 
   */
  setUsuario(){

    this.usuario = this.storage.getUsuario(); 

  }
  /**
   * 
   * On Data
   * 
   */
  onData(){

    this.usuarioService.emitUsuarioLogin.subscribe(usuario => {

      this.usuario = usuario; 

    });

  }
  /**
   * 
   * End pagamento
   * 
   */
  _endPagamento(response){ 

    try{

      this.isPagamento                              = true;
      this.carrinho.cart_dados.email                = response.email;
      this.carrinho.carrinho.file                   = response.dataFile.data; 
      this.carrinho.carrinho.solicitar_passageiros  = response.solicitar_passageiros;
      this.sendDataAnalytics();
      this.carrinho.pagamento = {
        info: response.dataPay.data
      };
      this.cart.emitirUpdateTotalCart.emit({
        total: 0, 
        qtd: 0
      });
      this.storage.remoteUltimolServico();
      /** DATA CONFIRMAÇÃO */
      this.data.setDataConfirmacao({
        id: this.carrinho.carrinho.id, 
        hash: this.carrinho.hash, 
        file: this.carrinho.carrinho.file,
        solicitar_passageiros: this.carrinho.carrinho.solicitar_passageiros,
        titular: {
          nome: response.nome,
          email: response.email,
          telefone: response.telefone,
          cpf: response.cpf,
          rg: response.rg, 
          data_nascimento: response.data_nascimento
        },
        dataPay: response.dataPay.data
      });
      /** ------------------ */
      this.app.toTop();  
      this.toConfirmacao();

    }catch(e){
      
    }  

  }
  /**
   * 
   * To confirmacao
   * 
   */
  toConfirmacao(){

    this.router.navigateByUrl("carrinho/finalizar-compra/confirmacao");

  }
  /***
   *
   * Envia os dados para o analytics
   *
   *
   */
  sendDataAnalytics() {
    try {
      
      let produtos      = [];
      let produtosPixel = [];
      let ids           = [];

      for (let index = 0; index < this.carrinho.cart_itens.length; index++) {
        
        produtos.push({
          "id": this.carrinho.cart_itens[index].servico_id,
          "name": this.carrinho.cart_itens[index].nome,
          "price": this.carrinho.cart_itens[index].total,
          "category": this.carrinho.cart_itens[index].categoria,
          'variant': 'Gray',
          'list_position': index + 1,
          "quantity": 1,
        });
        produtosPixel.push({
          "id": this.carrinho.cart_itens[index].servico_id,
          "quantity": (this.carrinho.cart_itens[index].qtd_adt+this.carrinho.cart_itens[index].qtd_chd+this.carrinho.cart_itens[index].qtd_inf+this.carrinho.cart_itens[index].qtd_snr)
        });
        ids.push(this.carrinho.cart_itens[index].servico_id);

      }
      this.gtag.sendPagamento(produtos,this.carrinho.total,this.carrinho.carrinho.file);
      this.fb.init();
      this.fb.purchase({
        total: this.carrinho.total
      });
      
    }
    catch (e) {
      
    }
  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit():void{
    this.getCart();  
    this.setItensBreadcrumbs();
    this.setUsuario();
    this.onData();
  }  

}
